/**
 * Simple Plans Portal
 *
 * @author      Anoopkumar
 * @copyright   2023 Simple Plans.
 * @license     -
 *
 **/

import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

// Redux Modules
import { useSelector, useDispatch } from "react-redux";
import {
  Navigate,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";

// page title bar
import PageTitleBar from "components/PageTitleBar/PageTitleBar";

import { AppTrlns } from "config";
import { AppConstants } from "modules/themes/config";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <div className="ecom-dashboard-wrapper">
      <Helmet>
        <title>Settings Dashboard</title>
        <meta name="description" content="Reactify Ecommerce Dashboard" />
      </Helmet>
      <PageTitleBar
        title={AppTrlns("Dashboard.sceneTitle")}
        location={location}
      />
      <section id="hero" className="d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-2 order-lg-1 aos-init aos-animate"
              data-aos="fade-up"
            >
              <div>
                <h1>Configuration Setings</h1>
                <h2>
                  Enables user to configure the appearance orr actions
                </h2>{" "}
              </div>
            </div>
            <div
              className="col-lg-6 d-lg-flex flex-lg-column align-items-stretch order-1 order-lg-2 hero-img aos-init aos-animate"
              data-aos="fade-up"
            >
              {" "}
              <img
                src={require("modules/themes/assets/img/dashboard.png")}
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
